<dx-box
    *ngIf="!isSmallScreen"
    [ngClass]="{ 'brand-image-container': isLarge, 'brand-image-container-md': isMedium }"
    direction="row"
>
    <dxi-item baseSize="auto" class="cc-header-icon" *ngIf="!brandImage">
        <img class="cc-header-brand-icon" [src]="logoImage" alt="{{ title }}" [title]="title" />
    </dxi-item>
    <dxi-item baseSize="auto" *ngIf="brandImage">
        <img class="cc-header-brand-icon" [src]="brandImage" alt="{{ brandAltText }}" [title]="brandAltText" />
    </dxi-item>
</dx-box>
